import { Injectable, Injector } from "@angular/core";
import { FormBuilder, FormGroup, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from "../service/toast.service";
import { LocalStorageService } from "../service/localstorage/localstorage.service";

@Injectable({ providedIn: "root" })
export abstract class BaseResourceForm {

  protected route: ActivatedRoute;
  protected router: Router;
  protected formBuilder: FormBuilder;
  protected message: ToastService;
  protected storage: LocalStorageService;
  public myForm!: FormGroup;

  constructor(protected injector: Injector) {
    this.route = this.injector.get(ActivatedRoute);
    this.router = this.injector.get(Router);
    this.formBuilder = this.injector.get(FormBuilder);
    this.message = this.injector.get(ToastService);
    this.storage = this.injector.get(LocalStorageService);
  }

  protected abstract createForm(): void;
  protected abstract submit(): void;

  isValidForm(): boolean {

    if (this.myForm.invalid) {
      Object.entries(this.myForm.controls).forEach(obj => {
        // console.log(obj)
        let o: any = obj[1];
        if (typeof o == 'object' && o?.controls) { // FormGroup tem valor de FormGroup ou FormArray
          if (Array.isArray(o.controls)) { //Se for FormArray
            (o.controls).forEach((e: UntypedFormGroup) => {
              // console.log(e.controls)
              Object.keys(e).forEach(key => {
                // console.log(e, key)
                (e.controls as FormGroup | any).get(key).markAsTouched();
              }, e)
            });
          } else //Se for FormGroup
            Object.keys(o.controls).forEach(key => {
              o.get(key).markAsTouched();
            })
        } else // FormuGroup com valor simples (string, boolean, number, ...)
          this.myForm.controls[obj[0]].markAsTouched();
      });
      this.message.showWarn('Por favor, preencha o formulário corretamente antes de enviar.');
      return false;
    }
    return true;
  }

  isFieldValid(field: any): boolean {
    return (!this.myForm.controls[field].valid && this.myForm.controls[field].touched && !this.myForm.controls[field].disabled);
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'is-invalid': this.isFieldValid(field)
    };
  }

  //Transforma json do formulario para parametros no formato string em requisições GET
  urlParametersToGet(url: string, params: {}) {
    let urlParameters = Object.entries(params).map((e: any) => (e[1]) ? e.join('=') : null).filter(Boolean).join('&');
    return url + '?' + urlParameters;
  }

  removeNullUndefinedWithReduce(obj: any) {
    return Object.entries(obj).reduce((acc: any, [key, value]) => {
      if (value !== null && value !== undefined) {
        acc[key] = typeof value === 'object' ? this.removeNullUndefinedWithReduce(value) : value;
      }
      return acc;
    }, {});
  }

}
